import {
    AfterViewInit,
    Component,
    ElementRef,
    HostListener,
    ViewChild,
} from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { SpinnerService } from '../../../../core/layout/spinner/spinner.service';

@Component({
    selector: 'pcg-fixed-buttons',
    templateUrl: './fixed-buttons.component.html',
    styleUrls: ['./fixed-buttons.component.scss'],
    standalone: false
})
export class FixedButtonsComponent implements AfterViewInit {
    @ViewChild('buttonContainer', { static: true }) buttonContainer!: ElementRef;

    setFixed$: Subject<void> = new Subject<void>();

    constructor(
        private elRef: ElementRef,
        private spinner: SpinnerService
    ) {
        this.setFixed$
            .pipe(debounceTime(25))
            .subscribe(() => this.onSetFixed());

        // Also make the nav fixed, if necessary, on AJAX calls
        this.spinner.loadingSource$.subscribe((spinnerVisible) => {
            if (!spinnerVisible) {
                this.setFixed();
            }
        });
    }

    /** Check whether or not the nav needs to be fixed on render */
    ngAfterViewInit() {
        this.setFixed();
    }

    /** This will trigger the onSetFixed logic
     *  It will be slightly delayed because of the debounce on the observable */
    @HostListener('document:click') setFixed() { this.setFixed$.next(); }

    @HostListener('document:scroll')
    @HostListener('window:resize')
    onSetFixed() {
        if (
            document.body.offsetHeight >
            this.elRef.nativeElement.getBoundingClientRect().top
        ) {
            this.buttonContainer?.nativeElement?.classList?.remove(
                'fixed-bottom-buttons'
            );
        } else {
            this.buttonContainer?.nativeElement?.classList?.add(
                'fixed-bottom-buttons'
            );
        }
    }
}
